export default __webpack_public_path__ + "static/media/css.b110e232.svg";